/**
 * Average Cost Zero Exception Config
 *
 * Covers: ex-inv-ls-avg-cost-zero
 *
 * Active inventory products whose average cost is zero at any outlet.
 */
import { buildProductExceptionConfig } from '../shared/productExceptionColumns'

export const avgCostZeroConfig = buildProductExceptionConfig({
  codes: ['ex-inv-ls-avg-cost-zero'],
  primaryErrorCode: 'avg_cost_missing',
})
